import { render, staticRenderFns } from "./Nestpay.vue?vue&type=template&id=55969fe4&scoped=true&"
import script from "./Nestpay.vue?vue&type=script&lang=js&"
export * from "./Nestpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55969fe4",
  null
  
)

export default component.exports